import { get, patch, post } from "../../../shared/data";

export const getProducts = (productKeys) => {
    return post("/receiving/shipments/products/search", { items: productKeys }).then((results) => {
        return results.map((u) => {
            return {
                ...u,
                packageLevelName: u.packageLevel && u.packageLevel.text ? u.packageLevel.text : "",
            };
        });
    });
};

export const getProduct = (productKey) => {
    return getProducts([productKey]).then((data) => {
        return data.find((p) => p.key === productKey);
    });
};

export const searchUpc = (upc) => {
    const url = `/tasking/contexts?upc=${upc}`;

    return get(url);
};

export const updateRelationships = (productKey, payload) => {
    return patch(`/receiving/shipments/products/${productKey}`, payload);
};
